"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastCalledDescriptionAdapter = void 0;
const lastCalledDescriptionAdapter = (qn) => {
    const descriptionMap = [
        { key: "queue:yksityisasiakas", value: "Yksityisasiakas" },
        { key: "queue:yritysasiakas", value: "Yritysasiakas" },
        { key: "queue:nettitilauksen-nouto", value: "Nettitilauksen nouto" },
    ];
    for (const mapped of descriptionMap) {
        if (qn.tags.indexOf(mapped.key) > -1)
            return mapped.value;
    }
    return "";
};
exports.lastCalledDescriptionAdapter = lastCalledDescriptionAdapter;
//# sourceMappingURL=lastCalledDescriptionAdapter.js.map